export default __webpack_public_path__ + "static/media/search.57b99492.png";